import { useContext } from 'react';
import { useNavigate } from 'react-router';
import useSWR from 'swr';
import { AuthContext } from '../../context/AuthContext';
import { getGetTodayGameUserCountUrl } from '../../api/generated/time-nyang/main/main.ts';
import catRunningBanner from '../../assets/images/banner-catrunning.png';
import mulnyangBanner from '../../assets/images/banner-mulnyang.png';

const PLAYGROUND_SCROLL_KEY = 'playground-scroll-top';

const stackingItems = [
  {
    id: 'cat-running',
    image: catRunningBanner,
    imageAlt: '캣러닝 배너',
    path: '/cat-running',
    countKey: 'catRunnerUserCount',
  },
  {
    id: 'fire-water',
    image: mulnyangBanner,
    imageAlt: '물냥불냥 배너',
    path: '/mulnyang-bulnyang',
    countKey: 'mulNyangUserCount',
  },
];

function formatParticipantCount(value) {
  const count = Number.isFinite(Number(value)) ? Number(value) : 0;
  return count.toLocaleString('ko-KR');
}

function PlaygroundStackingBannerItem({ image, imageAlt, participantCount, onClick }) {
  return (
    <article
      className={`flex w-full flex-col gap-1.5 ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <img
        src={image}
        alt={imageAlt}
        className="h-auto w-full rounded-[16px] object-cover"
      />
      <p className="px-4 text-xs font-bold leading-none font-['Pretendard']" style={{ color: '#D9D9D9' }}>
        {formatParticipantCount(participantCount)}명 참여중
      </p>
    </article>
  );
}

function PlaygroundStackingBannerList() {
  const navigate = useNavigate();
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { data: todayUsers } = useSWR(
    accessToken && [`${API_SERVER_DOMAIN}${getGetTodayGameUserCountUrl()}`, accessToken],
    fetchWithToken,
  );

  const saveAndNavigate = (path) => {
    const pageContainer = document.getElementsByClassName('page-container')[0];
    if (pageContainer) {
      const top = Math.max(pageContainer.scrollTop ?? 0, window.scrollY || 0);
      sessionStorage.setItem(PLAYGROUND_SCROLL_KEY, String(top));
    }
    navigate(path);
  };

  return (
    <div className="flex flex-col gap-4 px-2">
      {stackingItems.map((item) => (
        <PlaygroundStackingBannerItem
          key={item.id}
          image={item.image}
          imageAlt={item.imageAlt}
          participantCount={todayUsers?.[item.countKey]}
          onClick={item.path ? () => saveAndNavigate(item.path) : undefined}
        />
      ))}
    </div>
  );
}

export default PlaygroundStackingBannerList;
